import { useCallback, useEffect, useState } from "react";

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({ width: null, height: null });
  const updateWindowSize = useCallback(
    () =>
      setWindowSize({ width: window.innerWidth, height: window.innerHeight }),
    [setWindowSize]
  );

  useEffect(() => {
    updateWindowSize();
    window.addEventListener("resize", updateWindowSize);

    return () => window.removeEventListener("resize", updateWindowSize);
  }, []);

  return windowSize;
};
